import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, TextField } from "@material-ui/core";
import stylesPc from "./UploadDocument.module.css";
import stylesSp from "./UploadDocument_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import ShowFileIcon from "./ShowFileIcon";
import { VideoExtraMaterial } from "../../../common/video/models/VideoExtraMaterial";
import { ExtractFileName } from "../../../utils/ObjectUtils";
import PuiMessage from "../../../components/widgets/PuiMessage";
import { useInitFlag } from "../../../components/function/useInitFlag";

interface UploadDocumentProps {
    isShowAddDocIcon?: boolean;
    setIsSaved?: (isSaved: boolean) => void;
    alreadyUploadDocumentList: VideoExtraMaterial[];
    ChangeAlreadyUploadDocumentList?: (alreadyUploadDocumentList: VideoExtraMaterial[]) => void;
    ChangeDocumentList: (documentList: any[]) => void;
    documentList: any[];
    ChangeDocumentNameList: (documentNameList: string[]) => void;
    documentNameList: string[];
    ErrorDocumentListLength?: (isErrorDocumentListLength: boolean) => void;
}

export default function UploadDocument({
    isShowAddDocIcon,
    setIsSaved,
    ChangeDocumentList,
    alreadyUploadDocumentList,
    ChangeAlreadyUploadDocumentList,
    documentList,
    ChangeDocumentNameList,
    documentNameList,
    ErrorDocumentListLength,
}: UploadDocumentProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const inputRef = useRef<HTMLInputElement>(null);

    const [uploadDocumentFile, ChangeUploadDocumentFile] = useState(null);
    const [uploadDocumentFileType, ChangeUploadDocumentFileType] = useState("");
    const [uploadDocumentFileName, ChangeUploadDocumentFileName] = useState("");
    const [uploadDocumentName, ChangeUploadDocumentName] = useState("");
    const [limitDocumentNum, LimitDocumentNum] = useState(true);

    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };

    //Addアイコンにマウス入る処理
    const [isMouseEnterInfo, setMouseEnterInfo] = useState<boolean>(false);

    // 資料アップロード（資料名入力モーダルopen）
    const UserUploadDocument = (event: any) => {
        if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size >= 104857600) {
                    alert("100MB以下のサイズを指定してください");
                } else {
                    ChangeUploadDocumentFile(event.target.files[0]);
                    ChangeUploadDocumentFileType(event.target.files[0].type);
                    ChangeUploadDocumentFileName(event.target.files[0].name);
                    ChangeUploadDocumentName(ExtractFileName(event.target.files[0].name));
                    OpenUploadDocumentModal();
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputRef.current) {
                    inputRef.current.value = "";
                }
            }
        }
    };

    // 資料削除
    // コールバック
    const DeleteFile = (deleteFileIndex: number) => {
        if (alreadyUploadDocumentList) {
            if (deleteFileIndex >= alreadyUploadDocumentList.length) {
                const deleteUploadFileIndex = deleteFileIndex - alreadyUploadDocumentList.length;
                ChangeDocumentList(
                    documentList.filter((value, index) => index !== deleteUploadFileIndex)
                );
                ChangeDocumentNameList(
                    documentNameList.filter((value, index) => index !== deleteUploadFileIndex)
                );
            } else {
                ChangeAlreadyUploadDocumentList &&
                    ChangeAlreadyUploadDocumentList(
                        alreadyUploadDocumentList.filter(
                            (value, index) => index !== deleteFileIndex
                        )
                    );
            }
        } else {
            ChangeDocumentList(documentList.filter((value, index) => index !== deleteFileIndex));
            ChangeDocumentNameList(
                documentNameList.filter((value, index) => index !== deleteFileIndex)
            );
        }

        if (setIsSaved) {
            setIsSaved(false);
        }
    };

    // 資料アップロードモーダル画面表示制御
    const [isOpenUploadDocumentModal, ShowUploadDocumentModal] = useState(false);
    const [isErrorInputDocumentName, CheckInputDocumentName] = useState(false);
    // ファイル名重複エラー
    const [isDuplicateError, setDuplicateError] = useInitFlag();

    const OpenUploadDocumentModal = () => {
        ShowUploadDocumentModal(true);
    };

    const CloseUploadDocumentModal = () => {
        ShowUploadDocumentModal(false);
        CheckInputDocumentName(false);
        ChangeUploadDocumentFile(null);
        ChangeUploadDocumentFileType("");
        ChangeUploadDocumentFileName("");
        ChangeUploadDocumentName("");
        setDuplicateError(false);
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    };

    // 資料名入力
    const InputUploadDocumentName = (event: any) => {
        ChangeUploadDocumentName(event.target.value);
    };

    // ファイル名重複チェック
    const checkIsDuplicate = () => {
        let isDuplicate = false;
        const filenameList: string[] = [];

        if (documentList) {
            documentList.forEach((document) => {
                filenameList.push(document.name);
            });
        }
        if (alreadyUploadDocumentList) {
            alreadyUploadDocumentList.forEach((document) => {
                filenameList.push(document.fileName);
            });
        }

        const current = filenameList.find((name) => name === uploadDocumentFileName);
        if (current) {
            isDuplicate = true;
        }
        return isDuplicate;
    };

    // 資料名入力完了（追加ボタン押下）
    const DoneInputDocumentName = () => {
        if (checkIsDuplicate()) {
            setDuplicateError(true);
        } else {
            if (uploadDocumentName !== "") {
                const newDocList = [...documentList];
                newDocList.push(uploadDocumentFile);
                ChangeDocumentList(newDocList);
                documentList.push(uploadDocumentFile);

                const newDocNameList = [...documentNameList];
                newDocNameList.push(uploadDocumentName);
                ChangeDocumentNameList(newDocNameList);
                documentNameList.push(uploadDocumentName);
                CloseUploadDocumentModal();
                if (setIsSaved) {
                    setIsSaved(false);
                }
            } else {
                CheckInputDocumentName(true);
            }
        }
    };

    useEffect(() => {
        if (alreadyUploadDocumentList) {
            if (alreadyUploadDocumentList.length + documentList.length > 5) {
                LimitDocumentNum(true);
                if (ErrorDocumentListLength) ErrorDocumentListLength(true);
            } else {
                LimitDocumentNum(false);
                if (ErrorDocumentListLength) ErrorDocumentListLength(false);
            }
        } else {
            if (documentList.length > 5) {
                LimitDocumentNum(true);
                if (ErrorDocumentListLength) ErrorDocumentListLength(true);
            } else {
                LimitDocumentNum(false);
                if (ErrorDocumentListLength) ErrorDocumentListLength(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alreadyUploadDocumentList.length, documentList.length]);

    return (
        <div>
            <ul
                className={styles.documentForm}
                style={{
                    width: isShowAddDocIcon ? "auto" : "",
                }}
            >
                {isShowAddDocIcon ? (
                    <li className={styles.form}>
                        <div className={styles.formTag}>
                            <label
                                onMouseEnter={() => setMouseEnterInfo(true)}
                                onMouseLeave={() => setMouseEnterInfo(false)}
                            >
                                <input
                                    ref={inputRef}
                                    id="browserDocumentUploader"
                                    multiple
                                    type="file"
                                    onChange={UserUploadDocument}
                                    className={styles.fileDisplay}
                                />
                                {!isMouseEnterInfo && (
                                    <img
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        alt={"More"}
                                        src={require("../../../assets/image/MoreIcon.svg")}
                                    />
                                )}
                                {isMouseEnterInfo && (
                                    <img
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        alt={"More"}
                                        src={require("../../../assets/image/MoreIcon_hover.svg")}
                                    />
                                )}
                            </label>
                            <div
                                className={styles.descripionText}
                                style={{
                                    color: isShowAddDocIcon ? "rgba(255, 255, 255, 0.3)" : "",
                                }}
                            >
                                ファイルを追加（100MBまで）
                            </div>
                        </div>
                    </li>
                ) : (
                    <li className={styles.form}>
                        <label className={styles.uploadButton}>
                            <input
                                ref={inputRef}
                                id="browserDocumentUploader"
                                multiple
                                type="file"
                                onChange={UserUploadDocument}
                                className={styles.fileDisplay}
                                style={{
                                    color: isShowAddDocIcon ? "rgba(255, 255, 255, 0.3)" : "",
                                }}
                            />
                            ファイルを追加（100MBまで）
                        </label>
                    </li>
                )}

                {/* 資料一覧 */}
                {((alreadyUploadDocumentList && alreadyUploadDocumentList.length !== 0) ||
                    (documentList && documentList.length !== 0)) && (
                    <li
                        className={styles.inputDocumentList}
                        style={{
                            marginBottom: "0",
                            paddingLeft: isShowAddDocIcon ? "20px" : "44px",
                        }}
                    >
                        {alreadyUploadDocumentList &&
                            alreadyUploadDocumentList.map((document, index) => (
                                <div className={styles.icon} key={index}>
                                    <ShowFileIcon
                                        documentIndex={index}
                                        fileName={document.fileName}
                                        fileType={document.contentType}
                                        isVisibleFileName={true}
                                        isVisibleDeleteIcon={true}
                                        DeleteFile={DeleteFile}
                                        isWhiteColor={true}
                                    />
                                </div>
                            ))}
                        {documentList &&
                            documentList.map((document, index) => (
                                <div className={styles.icon} key={index}>
                                    <ShowFileIcon
                                        documentIndex={
                                            alreadyUploadDocumentList
                                                ? alreadyUploadDocumentList.length + index
                                                : index
                                        }
                                        fileName={documentNameList[index]}
                                        fileType={document.type}
                                        isVisibleFileName={true}
                                        showfileName={documentNameList[index]}
                                        isVisibleDeleteIcon={true}
                                        DeleteFile={DeleteFile}
                                        isWhiteColor={true}
                                    />
                                </div>
                            ))}
                    </li>
                )}

                {limitDocumentNum && (
                    <li className={styles.checkDocumentNum}>
                        ※アップロードできる資料は5つまでです
                    </li>
                )}
            </ul>

            {/* 資料確認モーダル */}
            <Modal open={isOpenUploadDocumentModal} onClose={CloseUploadDocumentModal}>
                <div className={styles.uploadDocumentModal}>
                    <div style={{ marginTop: "40px", marginBottom: "20px" }}>
                        <ShowFileIcon
                            fileName={uploadDocumentFileName}
                            fileType={uploadDocumentFileType}
                        />
                    </div>
                    <TextField
                        color="secondary"
                        id="uploadDocumentName"
                        onChange={InputUploadDocumentName}
                        style={{ width: "80%" }}
                        autoComplete="off"
                        variant="outlined"
                        placeholder="資料名を入力"
                        defaultValue={ExtractFileName(uploadDocumentFileName)}
                    />
                    <div className={styles.uploadDocumentModalButton}>
                        <Button
                            style={{ marginRight: "50px", width: "100px" }}
                            size="small"
                            variant="outlined"
                            type="submit"
                            color="secondary"
                            onClick={CloseUploadDocumentModal}
                        >
                            キャンセル
                        </Button>
                        <Button
                            style={{ width: "100px" }}
                            size="small"
                            variant="outlined"
                            type="submit"
                            color="secondary"
                            onClick={DoneInputDocumentName}
                        >
                            追加
                        </Button>
                    </div>
                    <div
                        className={styles.uploadDocumentModalAlart}
                        style={{ visibility: isErrorInputDocumentName ? "visible" : "hidden" }}
                    >
                        資料名を入力してください
                    </div>

                    <PuiMessage
                        open={isDuplicateError}
                        type="error"
                        title={uploadDocumentFileName + "はすでにアップロードされています。"}
                        duration={5000}
                        onClose={() => setDuplicateError(false)}
                    />
                </div>
            </Modal>

            <PuiMessage
                open={isErrorInputSize}
                type="error"
                title="正しいファイルを選択してください"
                duration={5000}
                onClose={CloseErrorInputBar}
            />
        </div>
    );
}
